/**
    Applies each key/value in an object as an attr.
    @param e The d3 selection to apply attributes to.
    @param a An object of key/value attr pairs.
*/ export default function(e) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    for(var k in a)if (({}).hasOwnProperty.call(a, k)) e.attr(k, a[k]);
}

//# sourceMappingURL=attrize.js.map